/**
 * Whether a menu entry should be highlighted for the current location.
 *
 * Menu links may carry a query string ("…/admin?tab=structure" opens the right admin tab),
 * but `location.pathname` never does — comparing the two raw would leave such an entry
 * permanently unselected. Only the path part takes part in the match, so the entry stays
 * highlighted while the user moves between the tabs of that page.
 */
export const isMenuLinkSelected = (pathname: string, itemLink?: string): boolean => {
  if (!itemLink) return false;

  const [linkPathname] = itemLink.split(/[?#]/);
  return pathname.startsWith(linkPathname);
};
